import React, {useState,useEffect} from 'react'
import apiClient from '../api/apiClient'

export default function AddTeacherModal(props){
    const {schoolID, testGroupID, addTeacher, onClose } = props
    const [teacherList, setTeacherList] = useState([])
    const [formData, setFormData] = useState({
        testGroupID: testGroupID, 
        teacherID : null, 
    })


    async function getTeachers(){
        try{
            const result = await apiClient.get('/api/testgroup/getteachers', {
                params: {schoolID: schoolID}
            })
            setTeacherList(result.data)
        }catch(e){
            console.log("error getting teachers")
            console.log(e)
        }
    }

    useEffect(()=>{
        getTeachers()
    }, [])

    function handleSubmit(e){
        e.preventDefault()

        addTeacher(formData)
        onClose()
    }

    return(
        <div className="modal-overlay">
            <div className="modal-content">
                <div className="modal-header">
                    <h2 className="modal-title">Tilføj underviser</h2>
                    <button classMenu="close-btn" onClick={onClose}>&times;</button>
                </div>
                <form onSubmit ={(e)=>handleSubmit(e)}>
                    <div className= "modal-form-grid">
                        <div className="form-group">
                            <label>Vælg underviser:</label>
                            <select value={formData.teacherID}
                                onChange={(e) => setFormData({...formData, teacherID: parseInt(e.target.value)})}>
                                <option key="0" value="0">Ingen valgt</option>
                                {teacherList.map(teacher => (
                                    <option key={teacher.id} value={teacher.id}>
                                        {teacher.fornavn} {teacher.efternavn}</option>
                                ))}
                            </select>
                                
                        </div>
                    </div>
                    <button className ="btn-cancel" type="button" onClick={onClose}>Annuller</button>
                    <button className ="btn-save" type="submit">Tilføj</button>
                </form>
            </div>
        </div>
    )
}  